import { FOOTER_HEIGHT } from '../../constants/layout';

export const footerFixed = {
  minHeight: FOOTER_HEIGHT,
  padding: '0.5rem',
  background: '#212529', // Darker standard background
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1000,
};

export const footerRelative = {
  height: FOOTER_HEIGHT + 5,
  background: '#212529', // Darker standard background
  opacity: .9,
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  left: '0',
  right: '0',
  bottom: '0',
  width: '100%',
  zIndex: 100,
  padding: '6px 12px',
  boxSizing: 'border-box',
};